export const SET_SETTINGS_LOADING   = 'SET_SETTINGS_LOADING';
export const SET_SETTINGS           = 'SET_SETTINGS';
export const SET_MAX_KEYS           = 'SET_MAX_KEYS';
export const SET_PRODUCT            = 'SET_PRODUCT';
export const SET_PLUGIN_INFO        = 'SET_PLUGIN_INFO';